import gql from 'graphql-tag';

export const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    users {
      delete(id: $id)
    }
  }
`;
